// extracted by mini-css-extract-plugin
module.exports = {"untilText":"az_yOc","closeText":"az_zOc"};